import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ReportsService } from 'src/app/services/reports.service';
import { UserService } from 'src/app/services/user.service';
import { StoreService  } from "../../../services/store.service";
import { SortableColumn } from '../../model/sort/sortable-column';
import { StoreMaintainenceResponse } from '../../model/store-maintainence-response';
import { StoreExport } from '../../model/store-export';
import { UserData } from '../../model/user-data';
import { UsersDataResponse } from '../../model/users-data-response';
import * as cloneDeep from 'lodash/cloneDeep';

@Component({
    selector: 'app-store-maintainence',
    templateUrl: './store-maintainence.component.html',
    styleUrls: ['./store-maintainence.component.scss'],
    standalone: false
})
export class StoreMaintainenceComponent implements OnInit,AfterViewInit {

  filter:string='';
  //displayedColumns: string[] = ['storeNumber', 'storeName', 'storeAddress', 'civicNumber', 'suiteNumber', 'streetName', 'streetType', 'streetDirection', 'city', 'provinceCode', 'details'];
  displayedColumns: string[] = ['storeNumber', 'storeName', 'civicNumber', 'suiteNumber', 'streetName', 'streetType', 'streetDirection', 'city', 'provinceCode', 'details'];
  dataSource :MatTableDataSource<StoreMaintainenceResponse>;
  sortableColumn: SortableColumn;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  storeData:StoreExport[]=[];
  exportButton:boolean=true;

  user: UsersDataResponse;
  userData: UserData;
  constructor(private storeservice:StoreService,private userservice:UserService,private router:Router,private reportservice:ReportsService){
    this.userservice.getCurrentUser().subscribe(data => {
      this.user = data;
      this.userData = data.userData;
    })
  }
  
  ngOnInit(): void {
    this.storeservice.getAllStores(this.userData.upn).subscribe(data=>{   
      this.dataSource=new MatTableDataSource<StoreMaintainenceResponse>(data);
      this.sort=new MatSort();
      this.dataSource.paginator = this.paginator;
      if(data.length>0){
      this.exportButton=false;
        this.populateStores(data);
      }
  
    });
  }

  populateStores(data){
    data.forEach((s:StoreMaintainenceResponse)=>{
      let str=new StoreExport();
      str.storeNumber=s.storeNumber
      //str.storeAddress=s.storeAddress;
      str.civicNumber=s.civicNumber;
      str.suiteNumber=s.suiteNumber;
      str.streetName=s.streetName;
      str.streetType=s.streetType;
      str.streetDirection=s.streetDirection;
      str.storeLicenseNumber=s.storeLicenseNumber;
      str.storeName=s.storeName;
      str.postalCode=s.postalCode;
      str.storeStatus=s.storeStatus;
      str.dcNumber=s.dcNumber;
      str.city=s.city;
      str.houseNumber=s.houseNumber;
      str.banner=s.banner;
      str.provinceCode=s.provinceCode;
      str.notes=s.notes;
      str.lastUpdatedTime=s.lastUpdatedTime;
    this.storeData.push(str);
    })
  }

  ngAfterViewInit() {
    this.sort=new MatSort();
   
    this.dataSource.sort = this.sort;

    //  this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);


  }
  viewStoreDetails(stores:StoreMaintainenceResponse){
    this.router.navigate(['/dcn-esign/store-management/edit-store',stores.sequenceNumber],{ queryParams: 
      { 'store-number':stores.storeNumber ,'action': 'store-edit' } });
    //this.router.navigate(['/dcn-esign/store-management/edit-store',stores.sequenceNumber]);
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.filter=filterValue;
    this.dataSource.filter = filterValue;
  }

  sortData(sort: Sort) {
    this.sortableColumn = new SortableColumn('', '', '');
    const sortedData: boolean | Array<any> = this.sortableColumn.sortTableData(sort, this.dataSource.data, this.displayedColumns);
    if (sortedData) {
      this.dataSource.data = sortedData as Array<any>;
    }
  }

  downloadStoreData(){
    this.reportservice.exportAsExcelFile(this.storeData, "domestic_contacts.xlsx");
  }
  
}
